import { ajaxCall } from "./ajax";

export function addErrorLogger() {
  window.onerror = function (message, source, lineno, colno, error) {
    message =
      message +
      " @ file:" +
      source +
      " @ lineno:" +
      lineno +
      " @ colno:" +
      colno;

    ajaxCall("sendErrorMessage", { url: window.location.href, message });
  };
}
